import { ToEmployeeProfileLink } from "@/modules/profile/pages/employee-profile";
import { PersonName } from "../person-name";
import type { PersonNameFormat } from "../person-name/utils/to-person-name";
import { PersonNameLinkFragment } from "gql/graphql";
import { Hidable, Value } from "@/shared/value";

export function PersonNameLink({
  data,
  link,
  format = "name",
}: {
  data?: Hidable<PersonNameLinkFragment>;
  link?: { className?: string };
  format?: PersonNameFormat;
}) {
  return (
    <Value data={data}>
      {(person) => (
        <ToEmployeeProfileLink id={person.id} className={link?.className}>
          <PersonName data={person} format={format} />
        </ToEmployeeProfileLink>
      )}
    </Value>
  );
}
